import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_CATE = `${BASE_URL}admin/getdata/get_gcategory.php`;
const API_GALLERY = `${BASE_URL}admin/getdata/get_gallery.php`;
const IMG_BASE = `${BASE_URL}admin/assets/gallery/`;

const AddGallery = () => {
  const [categories, setCategory] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [catId, setCatId] = useState("");
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= LOAD DATA ================= */
  const loadData = async () => {
    try {
      // CATEGORY (now returns plain array)
      const catRes = await axios.get(`${API_CATE}?action=list`);
      setCategory(catRes.data); // ← changed here

      // GALLERY (still using success/data structure)
      const galRes = await axios.get(`${API_GALLERY}?action=list`);
      if (galRes.data.success) {
        setGallery(galRes.data.data);
      }

    } catch (error) {
      console.error(error);
      setMessage("Error loading data");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  /* ================= FILE CHANGE ================= */
  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles(selected);

    const previews = selected.map((file) =>
      URL.createObjectURL(file)
    );
    setPreviewUrls(previews);
  };

  /* Cleanup preview URLs */
  useEffect(() => {
    return () => {
      previewUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [previewUrls]);

  /* ================= UPLOAD ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!catId) return setMessage("Please select a category");
    if (files.length === 0)
      return setMessage("Please select at least one image");

    const formData = new FormData();
    formData.append("cat_id", catId);
    files.forEach((file) => formData.append("images[]", file));

    try {
      setLoading(true);

      const res = await axios.post(
        `${API_GALLERY}?action=upload`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        setMessage("Images uploaded successfully!");
        setFiles([]);
        setPreviewUrls([]);
        setCatId("");
        loadData();
      } else {
        setMessage(res.data.error || "Upload failed");
      }

    } catch (err) {
      console.error(err);
      setMessage("Server error while uploading");
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;

    try {
      await axios.delete(`${API_GALLERY}?action=delete`, {
        data: { id },
      });
      loadData();
    } catch (error) {
      console.error(error);
      setMessage("Error deleting image");
    }
  };

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />
      <div className="content-wrapper">
        <Sidebar />

        <main className="main-wrapper clearfix">
          <div className="widget-list">
            <div className="container mt-4">
              <h3>Add Gallery</h3>

              {/* FORM */}
              <div className="card mt-3">
                <div className="card-body">

                  {message && (
                    <div className="alert alert-info py-2">
                      {message}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label>Category</label>
                      <select
                        className="form-control"
                        value={catId}
                        onChange={(e) => setCatId(e.target.value)}
                      >
                        <option value="">
                          Select Category
                        </option>

                        {categories.length > 0 &&
                          categories.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                              {cat.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>Gallery Images</label>
                      <input
                        type="file"
                        className="form-control"
                        multiple
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                      <small className="text-danger">
                        Recommended Size: 546px × 364px
                      </small>
                    </div>

                    {/* Preview */}
                    {previewUrls.length > 0 && (
                      <div className="mb-3 d-flex flex-wrap">
                        {previewUrls.map((url, i) => (
                          <img
                            key={i}
                            src={url}
                            alt="preview"
                            style={{
                              width: "120px",
                              height: "80px",
                              objectFit: "cover",
                              marginRight: "10px",
                              marginBottom: "10px",
                            }}
                          />
                        ))}
                      </div>
                    )}

                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Uploading..." : "Submit"}
                    </button>

                  </form>
                </div>
              </div>

              {/* LIST */}
              <div className="card mt-4">
                <div className="card-header">
                  Gallery List
                </div>

                <div className="card-body p-0">
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Caegory </th>
                        <th>Image</th>
                        <th width="100">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {gallery.length > 0 ? (
                        gallery.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                             <td>{item.name}</td>
                            <td>
                              <img
                                src={IMG_BASE + item.image}
                                alt=""
                                style={{
                                  width: "120px",
                                  height: "80px",
                                  objectFit: "cover",
                                }}
                              />
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  handleDelete(item.id)
                                }
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No gallery images found
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                </div>
              </div>

            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default AddGallery;